import { useState } from "react";
import "./index.css";
import NavBar from "./components/NavBar";
import HeadingComp from "./components/HeadingComp";
import { Container } from "react-bootstrap";
import CardComp from "./components/CardComp";
import { dataOfItems } from "./data";
const App = () => {
  const [filteredItems, setFilteredItems] = useState(dataOfItems);
  const filterByButton = (cat) => {
    if (cat === "all") {
      setFilteredItems(dataOfItems);
    } else {
      const filteredData = dataOfItems.filter((item) => {
        return item.category === cat;
      });
      setFilteredItems(filteredData);
    }
  };
  // Unique Categories
  const uniqueCarories = [
    "all",
    ...new Set(dataOfItems.map((item) => item.category)),
  ];
  const filterBySearch = (word) => {
    const filteredData = dataOfItems.filter((item) => {
      return item.title.includes(word);
    });
    setFilteredItems(filteredData);
  };
  return (
    <div>
      <NavBar search={filterBySearch} />
      <Container className="mt-4">
        <HeadingComp filterFunc={filterByButton} cats={uniqueCarories} />
        <CardComp data={filteredItems} />
      </Container>
    </div>
  );
};

export default App;
